// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"style_containerBox__1F2LG","contantBox":"style_contantBox__2PmtM","titleBox":"style_titleBox__2yN9P"};